<template>
  <v-card elevation="0">
    <v-card-title> Общие свойства комплектов </v-card-title>
    <v-card-text>
      <CategorySelectComponent
        :items="gCategories"
        label="Категория товаров"
        @change="updateGCatRid"
        :value="goodCategory"
      />
      <CategorySelectComponent
        :items="aCategories"
        label="Бух. категория товаров"
        @change="updateACatRid"
        :value="accountingCategory"
      />
      <br />
      Корневая группа товаров созданных на основе комплектов
      <CustomTree
        :items="gGroups"
        :updateFunc="updateParsedByKey"
        :createFunc="createGroup"
        updateKey="goodsGroupRid"
        :selected="parsed.goodsGroupRid"
      />
      <v-divider />
      Корневая группа комплектов
      <CustomTree
        :items="packageGroups"
        :createFunc="createPackageGroup"
        updateKey="packageGroupRid"
        :updateFunc="updateParsedByKey"
        :selected="parsed.packageGroupRid"
      />
      Корневая группа комплектов (полуфабрикаты)
      <CustomTree
        :items="packageGroups"
        :createFunc="createPackageGroup"
        updateKey="prepackGroupRid"
        :updateFunc="updateParsedByKey"
        :selected="parsed.prepackGroupRid"
      />
    </v-card-text>
    <v-card-title> Соотношение столбцов </v-card-title>
    <v-card-subtitle> Древо групп </v-card-subtitle>
    <v-card-text>
      <TreeColumns />
    </v-card-text>
    <v-card-subtitle> Декомлектация </v-card-subtitle>
    <v-card-text>
      <PackageColumns />
    </v-card-text>
    <v-card-actions> </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CategorySelectComponent from "../CategorySelectComponent";
import CustomTree from "../CustomTree.vue";
import TreeColumns from "./columns/TreeColumns";
import PackageColumns from "./columns/PackageColumns";

export default {
  computed: {
    ...mapGetters([
      "gGroups",
      "packageGroups",
      "gCategories",
      "aCategories",
      "parsed",
    ]),
    goodCategory() {
      return this.gCategories.find((e) => e.rid == this.parsed.CategoryRid);
    },
    accountingCategory() {
      return this.gCategories.find((e) => e.rid == this.parsed.AccCategoryRid);
    },
  },
  components: {
    CategorySelectComponent,
    CustomTree,
    TreeColumns,
    PackageColumns,
  },
  methods: {
    ...mapActions(["updateParsedByKey", "createGroup", "createPackageGroup"]),
    updateGCatRid(val) {
      this.updateParsedByKey({ key: "CategoryRid", val });
    },
    updateACatRid(val) {
      this.updateParsedByKey({ key: "AccCategoryRid", val });
    },
  },
};
</script>
